import { memo } from 'react';
import { NodeProps } from 'reactflow';
import { BaseNode } from './BaseNode';

export const ButtonNode = memo((props: NodeProps) => {
  const buttons: { id: string; text: string }[] = props.data.config?.buttons || [];
  const count = buttons.filter((b) => b.text?.trim()).length;

  const description = count > 0
    ? `${count} opção${count > 1 ? 'ões' : ''}: ${buttons.map((b) => b.text).filter(Boolean).join(', ').substring(0, 30)}`
    : 'Configure os botões';

  return (
    <BaseNode
      {...props}
      description={description}
      onDelete={props.data.onDelete}
    />
  );
});

ButtonNode.displayName = 'ButtonNode';
